(() => {
  const cookieName = 'opti_params';
  const maxAge = 430 * 24 * 60 * 60;
  const keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'fbclid', 'gclid', 'msclkid', 'wbraid', 'gbraid'];

  const existing = document.cookie.split('; ').find((cookie) => cookie.startsWith(`${cookieName}=`));
  let params = {};

  if (existing) {
    try {
      params = JSON.parse(decodeURIComponent(existing.slice(cookieName.length + 1)));
      if (params === null || Array.isArray(params) || Object.getPrototypeOf(params) !== Object.prototype) params = {};
    } catch {
      params = {};
    }
  }

  const search = new URLSearchParams(window.location.search);
  for (const key of keys) {
    const value = search.get(key);
    if (value) params[key] = value;
  }

  if (Object.keys(params).length) {
    document.cookie = `${cookieName}=${encodeURIComponent(JSON.stringify(params))}; Max-Age=${maxAge}; Path=/; SameSite=Lax`;
  }
})();
